<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>edit</v-icon> Editar solicitud con cargo a vacación
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text class="pt-0">
          <v-container grid-list-md class="py-0" style="min-width: 100%;">
            <v-layout row wrap>
              <v-flex xs12>
                <v-card
                  v-if="form && form.sw_programacion"
                  color="indigo"
                  class="px-3 white--text text-xs-center text-md-left"
                >
                  <v-layout row wrap>
                    <v-flex xs12
                      ><span class="caption">TOTAL DÍAS RESERVA RESTANTES</span
                      ><br />
                      <span class="display-1">
                        {{
                          form.dias_reserva - form.total_dias_creados_reserva
                        }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-card v-else color="indigo" class="px-3 white--text ">
                  <v-flex xs12 md6>
                    <span class="caption"
                      >TOTAL DÍAS NO PROGRAMADOS RESTANTES</span
                    ><br />
                    <span class="display-1">{{
                      form.saldo_no_programadas
                    }}</span>
                  </v-flex>
                </v-card>
              </v-flex>

              <!-- <p class="titulo">Total días no programados :</p>
              <p class="texto">{{ this.form.saldo_no_programadas }} dias</p> -->
            </v-layout>

            <!-- <v-layout row wrap>
              <p class="titulo">Total días solicitados :</p>
              <p class="texto">{{ this.total_dias_solicitadas }} dias</p>
            </v-layout> -->
            <v-layout row wrap>
              <v-flex xs12 md4>
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha"
                  :rules="$validate(['required'])"
                  required
                  @input="calculaDiasSolicitados(false)"
                  @change="calculaDiasSolicitados(true)"
                  outline
                />
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_retorno"
                  label="Fecha hasta"
                  :rules="$validate(['required'])"
                  required
                  @input="calculaDiasSolicitados(false)"
                  @change="calculaDiasSolicitados(true)"
                  outline
                />
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-if="
                    form.fecha_desde &&
                      form.fecha_retorno &&
                      (form.rango_horario == 1 ||
                        form.rango_horario == 2 ||
                        form.rango_horario == 0)
                  "
                  class="text-field-reducido-border"
                  v-model="total_dias"
                  label="Días"
                  disabled
                  outline
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
              <v-flex shrink>
                <v-radio-group
                  class="text-field-reducido"
                  v-model="form.rango_horario"
                  row
                  @change="calculaDiasSolicitados(true)"
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs4>
                    <v-radio label="Todo el día" :value="0"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo mañana" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo tarde" :value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn @click.native="close()" color="error">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="save()">
            <v-icon>save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogEditarPermisoCargoVacacion", async item => {
      this.form = { ...item };
      this.form.fecha_desde = this.$moment(
        this.form.fecha_desde,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");

      this.form.fecha_retorno = this.$moment(
        this.form.fecha_retorno,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      await this.obtieneTiempoVacacion();
      await this.calculaDiasSolicitados();
      // await this.calculaDiferenciaDias();

      this.dialog = true;
    });
    await this.verEstadoVacacion();
  },
  data() {
    return {
      form: {},
      radio_data: "",
      dialog: false,
      valid: false,
      loading: false,
      total_dias: 0,
      total_dias_no_programados: 0,
      headers: [
        {
          text: "Fecha salida",
          sortable: false
        },
        {
          text: "Fecha hasta",
          sortable: false
        },
        {
          text: "Hora desde",
          sortable: false
        },
        {
          text: "Hora hasta",
          sortable: false
        },
        {
          text: "Rango día",
          sortable: false
        },
        {
          text: "Acción",
          sortable: false
        }
      ],
      // variables nueva funcionalidad
      tiempo_vacaciones: 0,
      total_dias_solicitadas: 0
    };
  },
  methods: {
    // Metodo para obtener el tiempo de vacaciones que posee el funcionario
    async obtieneTiempoVacacion() {
      let id_persona;
      let user = this.$storage.get("user");
      if (this.$route.params.id == null || this.$route.params.id == undefined) {
        id_persona = user.id_persona;
      } else {
        id_persona = this.$route.params.id;
      }
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select vacaciones.fn_obtiene_saldo_vacacion_por_persona(${id_persona})"){
              respuesta
              }
            }	
          `
        });
        let resp =
          respuesta.runQuery.respuesta[0].fn_obtiene_saldo_vacacion_por_persona;
        resp = resp.split("|");
        this.tiempo_vacaciones = parseFloat(resp[1]);
      } catch (error) {
        console.log(error);
      }
    },
    async calculaDiferenciaDias() {
      try {
        let res;
        if (
          this.form.fecha_desde &&
          this.form.fecha_retorno &&
          (this.form.rango_horario == 1 ||
            this.form.rango_horario == 2 ||
            this.form.rango_horario == 0)
        ) {
          res = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select vacaciones.fn_obtiene_dias_habiles_entre_fechas('${this.form.fecha_desde}','${this.form.fecha_retorno}')"){
								respuesta
							}
							}
						`
          });
          let res2;
          if (this.form.rango_horario == 1 || this.form.rango_horario == 2) {
            res2 =
              parseInt(
                res.runQuery.respuesta[0].fn_obtiene_dias_habiles_entre_fechas
              ) / 2;
          }
          if (this.form.rango_horario == 0) {
            res2 =
              res.runQuery.respuesta[0].fn_obtiene_dias_habiles_entre_fechas;
          }

          this.total_dias = res2;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para calcular los dias solicitados
    async calculaDiasSolicitados(bandera_mensaje) {
      if (
        this.form.fecha_desde &&
        this.form.fecha_retorno &&
        this.form.rango_horario != null
      ) {
        try {
          let res = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select general.fn_cuenta_dias_habiles_por_persona('${
                this.form.fecha_desde
              }','${this.form.fecha_retorno}',${this.getPersonaId()})"){
								respuesta
							}
							}
						`
          });
          let res2;
          if (this.form.rango_horario == 1 || this.form.rango_horario == 2) {
            res2 =
              parseInt(
                res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona
              ) / 2;
          }
          if (this.form.rango_horario == 0) {
            res2 = res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona;
          }
          this.total_dias_solicitadas = res2;
          this.total_dias = res2;

          // let respuesta = await this.$service.graphql({
          //   query: `
          //   query{
          //     runQuery(consulta:"select control.fn_obtiene_dias_por_ranfo('${
          //       this.form.fecha_desde
          //     }','${this.form.fecha_retorno}',${parseInt(
          //     this.getPersonaId()
          //   )},${tipo_dia})"){
          //       respuesta
          //     }
          //   }
          // `
          // });
          // respuesta = respuesta.runQuery.respuesta[0].fn_obtiene_dias_por_ranfo;
          // this.total_dias_solicitadas = parseFloat(respuesta);
        } catch (error) {
          console.log(error);
        }
      } else {
        if (bandera_mensaje) {
          this.$message.info("Complete todos los campos");
        }
      }
    },
    //hallar el saldo de vacaciones programas
    async verEstadoVacacion() {
      let user = this.$storage.get("user");
      try {
        let res = await this.$service.graphql({
          query: `
						
						query{
                  vEstadoVacacions(id_persona: ${parseInt(
                    this.getPersonaId()
                  )}){
                    rows{
                       nombre
                      dias_saldo
                      dias_asignados
                      dias_utilizados
                      dias_programados
                      dias_cta_vacacion
                      id
                      id_estado
                      id_persona
                      nombre
                      ingreso
                      gestion_desde
                      gestion_hasta
                      cas
                      estado
                      dias_a_programar
                      total_dias_saldo
                      saldo_a_programar
                    }
                  }
                } 
					`
        });
        let estado_vacacion = res.vEstadoVacacions.rows;
        //dias no programados
        let id_persona;
        if (
          this.$route.params.id == null ||
          this.$route.params.id == undefined
        ) {
          id_persona = user.id_persona;
        } else {
          id_persona = this.$route.params.id;
        }
        let fecha_act = new Date();

        let gestion_vigente = fecha_act.getFullYear();
        let resp2;
        resp2 = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select vacaciones.fn_obtiene_dias_para_cuenta_vacacion(${id_persona},${parseInt(
            gestion_vigente
          )})"){
                  respuesta
                  }
                }	
              `
        });
        if (
          resp2.runQuery.respuesta[0].fn_obtiene_dias_para_cuenta_vacacion !=
            null ||
          resp2.runQuery.respuesta[0].fn_obtiene_dias_para_cuenta_vacacion
        ) {
          if (
            parseFloat(
              resp2.runQuery.respuesta[0].fn_obtiene_dias_para_cuenta_vacacion
            ) < 0.5
          ) {
            this.total_dias_no_programados = 0;
          } else {
            resp2 =
              resp2.runQuery.respuesta[0].fn_obtiene_dias_para_cuenta_vacacion;
            resp2 = resp2.split("|");
            this.total_dias_no_programados = resp2[1];
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Obtiene el horario de una persona
    async obtenerHorarioPersona(id_persona, id_radio_data) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select control.fn_rango_horario_por_persona_solo_horarios(${parseInt(
                id_persona
              )},${parseInt(id_radio_data)},'${this.form.fecha_desde}')"){
                respuesta
              }
            }
          `
        });
        if (
          respuesta.runQuery.respuesta[0]
            .fn_rango_horario_por_persona_solo_horarios != null
        ) {
          respuesta = respuesta.runQuery.respuesta[0].fn_rango_horario_por_persona_solo_horarios.split(
            "|"
          );
          if (respuesta[0] != "0") {
            return [respuesta[0], respuesta[1]];
          } else {
            return "No";
          }
        } else {
          this.$message.warning(
            "Sin horario asignado para la fecha del permiso"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para comprobar si existen otros permisos en el mismo periodo
    async verificarPermisosRango(
      fecha_desde,
      fecha_hasta,
      hora_desde,
      hora_hasta,
      id_permiso
    ) {
      //Funcion notifica que hay un permiso creado en el rango de fechas seleccionado
      // control.fn_muestra_permisos_funcionario(p_id_persona integer, p_fecha date)
      let existePermisos = false;
      let permisos = "¿Esta seguro guardar el permiso?";
      let permisos_consulta = "";
      let respuesta;

      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_permisos_por_funcionario_actualiza(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}',${parseInt(
            id_permiso
          )})"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_permisos_por_funcionario_actualiza;
        respuesta = respuesta.split("|");

        if (respuesta[0] == "1") {
          existePermisos = true;
          permisos_consulta +=
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            respuesta[1].replace(/#/g, "<br>");
        }
      } catch (error) {
        console.log(error);
      }
      if (existePermisos) {
        this.$alert("No puede crear el permiso" + permisos_consulta);
      }
      return [existePermisos, permisos + permisos_consulta];
    },
    close() {
      this.dialog = false;
      this.permiso = {};
      this.radio_data = null;
      this.$bus.$emit("closeDialogPapeletaVacacion");
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");
      return a[3];
    },
    async save() {
      let respuesta;
      let user = this.$storage.get("user");
      try {
        if (!this.$refs.form.validate()) {
          return
        }
        if (
          (!this.form.sw_programacion &&
            this.total_dias_solicitadas <=
              this.form.saldo_no_programadas +
                parseFloat(this.form.nro_dias)) ||
          (this.form.sw_programacion &&
            this.total_dias_solicitadas <=
              parseFloat(this.form.dias_reserva) -
                parseFloat(this.form.total_dias_creados_reserva) +
                parseFloat(this.form.nro_dias))
        ) {
          // Sumamos dias de la vacacion ya que se esta editando
          let horario = await this.obtenerHorarioPersona(
            parseInt(this.getPersonaId()),
            this.form.rango_horario
          );
          if (horario != "No") {
            let consulta = await this.verificarPermisosRango(
              this.form.fecha_desde,
              this.form.fecha_retorno,
              horario[0],
              horario[1],
              this.form.id_permiso
            );
            if (consulta[0] == true) {
              return;
            }
            this.$confirm(consulta[1], async () => {
              respuesta = await this.$service.graphql({
                query: `
                query{
                  runQuery(consulta:"select control.fn_actualiza_cta_vacacion(${
                    this.form.id_permiso
                  },'${this.form.fecha_desde}','${this.form.fecha_retorno}','${
                  horario[0]
                }','${horario[1]}',${parseInt(user.id)},${parseInt(
                  this.form.rol
                )})"){
                  respuesta
                  }
                }	
              `
              });
              let resp =
                respuesta.runQuery.respuesta[0].fn_actualiza_cta_vacacion;
              let resps = resp.split("|");
              let correcto = resps[0];
              if (correcto == "1") {
                this.$message.success("Modificación exitosa");
                this.close();
              } else {
                this.$message.error(resps[1]);
              }
            });
          } else {
            this.$message.info("No tiene un horario laboral asignado");
          }
        } else {
          this.$message.info("Excede el total de dias de su saldo de vacacion");
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
.titulo {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/papeleta_vacacion/dialogs/EditarPermisoCargoVacacion.vue